/**
 * 登录弹框
 */
import Vue from 'vue'

import LoginVue from './index.vue'

let LoginModalConstructor = Vue.extend(LoginVue)

let instance

const LoginModal = function (options = {}) {
    // 服务器渲染
    if (Vue.prototype.$isServer) return
    options = options || {}
    if (typeof options !== 'object') return
    const userOnClose = options.onClose // 自定义关闭
    // 关闭事件
    options.onClose = function () {
        LoginModal.close(userOnClose)
    }
    instance = new LoginModalConstructor({
        data: options
    })
    instance.$mount()
    document.body.appendChild(instance.$el) //  this.$el 拿到组件实际上的dom，把他挂载到body上
}

LoginModal.close = (userOnClose)=>{
    if (typeof userOnClose === 'function') {
        userOnClose(instance)
    }
}

export default LoginModal;